import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer, { initialRootState } from './root-reducer';
import { rootSaga } from './root-saga';

const composeEnhancers = composeWithDevTools({});
const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, initialRootState, composeEnhancers(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootSaga);

export * from './authentication';
export * from './customer';
export * as admin from './admin';
export * as encoders from './encoders';
export * as regions from './regions';
export * from './root-reducer';
export { rootReducer, rootSaga };

export default store;
